"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.separator = exports.pageButton = exports.nextButton = exports.button = exports.root = void 0;

var _emotion = require("emotion");

var _consts = require("./consts");

var root =
/*#__PURE__*/
(0, _emotion.css)("display:flex;flex-direction:row;height:", _consts.PAGINATION_HEIGHT, "px;align-items:center;");
exports.root = root;
var button =
/*#__PURE__*/
(0, _emotion.css)("padding:0px 24px;height:", _consts.PAGINATION_HEIGHT, "px;width:auto;min-width:auto;");
exports.button = button;
var nextButton =
/*#__PURE__*/
(0, _emotion.css)("margin-left:8px;");
exports.nextButton = nextButton;

var pageButton = function pageButton(theme, isSelected, number) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:500;cursor:pointer;font-stretch:normal;font-style:normal;line-height:1.71;letter-spacing:normal;height:", _consts.PAGINATION_HEIGHT, "px;min-width:", _consts.PAGINATION_HEIGHT, "px;border-radius:2px;color:", theme.color.dark.iron, ";&:focus{outline:0;}", !isSelected &&
    /*#__PURE__*/
    (0, _emotion.css)("margin:0 14px;&:hover{background-color:", theme.color.dark.white0_06, ";}"), ";", isSelected &&
    /*#__PURE__*/
    (0, _emotion.css)("background-color:", theme.color.dark.sapphire, ";color:", theme.color.dark.silver, ";margin:0 15px;"), ";", number > 9 &&
    /*#__PURE__*/
    (0, _emotion.css)("padding:0 2px;"), ";", number > 99 &&
    /*#__PURE__*/
    (0, _emotion.css)("padding:0 7px;"), ";")
  );
};

exports.pageButton = pageButton;

var separator = function separator(theme) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("color:", theme.color.dark.iron, ";font-size:14px;font-weight:400;font-stretch:normal;font-style:normal;line-height:1.71;letter-spacing:normal;margin-left:-14px;margin-right:-14px;")
  );
};

exports.separator = separator;